angular.module('app').config(function (ngAboutRoutesConfigurationProvider) {
  ngAboutRoutesConfigurationProvider.state('my.about');
});
